/**
 * Drives Horizon's native variant picker from a custom swatch UI. Never
 * duplicates variant/price/availability logic — it only locates the real
 * `options[<name>]` input Horizon's own variant-picker component listens on
 * and dispatches the same `change` event a real user interaction would,
 * so the existing add-to-cart/price/section-morph logic runs unchanged.
 */
class CrFinishSwatches extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  #onClick = (event) => {
    const button = event.target.closest('.cr-finish-swatches__swatch');
    if (!button) return;

    const optionName = this.dataset.optionName;
    const optionValue = button.dataset.optionValue;
    const inputName = `options[${optionName}]`;

    const picker = this.closest('variant-picker, .product-form, product-form-component') ?? document;

    const select = picker.querySelector(`select[name="${CSS.escape(inputName)}"]`);
    if (select) {
      const option = Array.from(select.options).find((o) => o.value === optionValue);
      if (option) {
        select.value = optionValue;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }

    const radio = picker.querySelector(
      `input[name="${CSS.escape(inputName)}"][value="${CSS.escape(optionValue)}"]`
    );
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };
}

if (!customElements.get('cr-finish-swatches')) {
  customElements.define('cr-finish-swatches', CrFinishSwatches);
}
